import React from 'react'

const Stepone = () => {
  return (
    <div>Stepone</div>
  )
}

export default Stepone